import { createCrudSlice } from './createCrudSlice';
import { elevationsApi } from '../../services/api';

const { reducer, actions } = createCrudSlice('elevations', elevationsApi);

export const {
  fetchAll: fetchElevations,
  fetchById: fetchElevationById,
  create: createElevation,
  update: updateElevation,
  remove: deleteElevation,
  clearError,
  clearCurrentItem,
} = actions;

export default reducer;
